import { render, staticRenderFns } from "./TableColumnsConfig.vue?vue&type=template&id=81ce6d98&"
import script from "./TableColumnsConfig.vue?vue&type=script&lang=js&"
export * from "./TableColumnsConfig.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnsConfig.vue?vue&type=style&index=0&id=81ce6d98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports